import React, { CSSProperties } from "react";
import _ from "lodash";
import { FontAwesomeIcon, FontAwesomeIconProps } from "@fortawesome/react-fontawesome";
import {
    IconProp,
    FlipProp,
    SizeProp,
    PullProp,
    RotateProp,
    Transform,
    FaSymbol,
} from "@fortawesome/fontawesome-svg-core";
import {
    faDownload,
    faUpload,
    faSync,
    faTimes,
    faCheck,
    faSignOutAlt,
    faSearch,
    faHome,
    faPencilAlt,
    faTrashAlt,
    faExclamationTriangle,
    faPlay,
    faInfoCircle,
    faExternalLinkAlt,
} from "@fortawesome/free-solid-svg-icons";

export type IconName = "download" | "upload" | "refresh" | "times" | "check" | "sign-out" |
    "search" | "home" | "pencil" | "trash" | "exclamation-triangle" | "play" |
    "info-circle" | "external";
export interface IconProps {
    name?: IconName;
    icon?: IconProp;
    mask?: IconProp;
    className?: string;
    color?: string;
    spin?: boolean;
    pulse?: boolean;
    border?: boolean;
    fixedWidth?: boolean;
    inverse?: boolean;
    listItem?: boolean;
    flip?: FlipProp;
    size?: SizeProp;
    pull?: PullProp;
    rotation?: RotateProp;
    transform?: string | Transform;
    symbol?: FaSymbol;
    style?: CSSProperties;
    tabIndex?: number;
    title?: string;
    swapOpacity?: boolean;
}

export const Icon = (props: IconProps) => {
    const { name } = props;
    let { icon } = props;
    switch (name) {
        case "download":
            icon = faDownload;
            break;
        case "upload":
            icon = faUpload;
            break;
        case "refresh":
            icon = faSync;
            break;
        case "times":
            icon = faTimes;
            break;
        case "check":
            icon = faCheck;
            break;
        case "sign-out":
            icon = faSignOutAlt;
            break;
        case "search":
            icon = faSearch;
            break;
        case "home":
            icon = faHome;
            break;
        case "pencil":
            icon = faPencilAlt;
            break;
        case "trash":
            icon = faTrashAlt;
            break;
        case "exclamation-triangle":
            icon = faExclamationTriangle;
            break;
        case "play":
            icon = faPlay;
            break;
        case "info-circle":
            icon = faInfoCircle;
            break;
        case "external":
            icon = faExternalLinkAlt;
            break;
    }
    const faProps: FontAwesomeIconProps = {
        icon,
        ..._.omit(props, ["name"]),
    };
    return <FontAwesomeIcon {...faProps} />;
};
